import { grey } from '@mui/material/colors';

export default {
  styleOverrides: {
    root: {
      fontWeight: 300,
      backgroundColor: grey[200],
      padding: 24,
      marginBottom: 16,
    },
  },
};
